// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"76":"09482f5c","106":"650b8171","113":"1dae5cb3","142":"9e45b08f","358":"619c29bf","438":"3f2bf572","624":"0564fabb","648":"86ceacf2"}[chunkId] + ".chunk.js";
};